export const aciPoolChildren = {
    iconName: 'pool-children',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 25' },
        path: {
            attr: {
                d: 'M2 20.235a7.657 7.657 0 002.99.201c1.005-.13 1.934-.455 2.677-.936.99.642 2.302 1 3.666 1 1.364 0 2.676-.358 3.667-1 .935.606 2.16.96 3.446.997 1.286.036 2.549-.247 3.554-.799M12.43 15.358a5.43 5.43 0 100-10.858 5.43 5.43 0 000 10.858zM13.787 12.281a2.714 2.714 0 01-2.715 0M12.43 4.5a1.357 1.357 0 110 2.715M10.082 9.141c0 .09.017-.064-.047 0M14.804 9.141c0 .09.018-.064-.046 0',
                stroke: 'currentColor',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
            },
        },
    },
};
